export var migrations = {};
export default migrations;